"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchCheckRatioEvents = fetchCheckRatioEvents;
const maps_js_1 = require("../../common/maps.js");
const fetchEvents_js_1 = require("./fetchEvents.js");
async function fetchCheckRatioEvents(params) {
    const eventTypesSet = new Set();
    if (params.poolNames) {
        params.poolNames.forEach((poolName) => {
            if (maps_js_1.poolInfo[poolName].strategyType !== "LOOPING" &&
                maps_js_1.poolInfo[poolName].strategyType !== "SINGLE-LOOPING") {
                console.error("Check Ratio event only applicable in looping pools");
                throw new Error("Inavlid Params");
            }
            const eventType = maps_js_1.poolInfo[poolName].checkRatioEventType;
            if (eventType !== undefined && eventType !== null && eventType !== "") {
                eventTypesSet.add(eventType);
            }
        });
    }
    else {
        // Iterate over all the values in poolInfo and add each checkRatioEventType to the Set
        Object.values(maps_js_1.poolInfo).forEach((info) => {
            const eventType = info.checkRatioEventType;
            if (eventType !== undefined && eventType !== null && eventType !== "") {
                eventTypesSet.add(eventType);
            }
        });
    }
    const eventTypes = Array.from(eventTypesSet);
    const eventsPromises = eventTypes.map(async (eventType) => {
        const events = await (0, fetchEvents_js_1.fetchEvents)({
            startTime: params.startTime,
            endTime: params.endTime,
            eventTypes: [eventType],
            order: params.order,
        });
        return events;
    });
    const events = (await Promise.all(eventsPromises)).flat();
    const checkRatioEvents = events.map((e) => {
        return e;
    });
    return checkRatioEvents;
}
//# sourceMappingURL=fetchCheckRatioEvents.js.map